export enum ParkingSubscriptionType {
  Personal = 'Personal',
  TenantParkingPool = 'TenantParkingPool',
}

export enum ParkingSubscriptionStatus {
  active = 'active',
  cancelled = 'cancelled',
  error = 'error',
  new = 'new',
  past = 'past',
  pending = 'pending',
}

export enum ReservationStatus {
  cancelled = 'cancelled',
  error = 'error',
  finished = 'finished',
  prereserved = 'prereserved',
  rented = 'rented',
  reserved = 'reserved',
}
